// Unified API that works with both localStorage and Supabase
import { localApi } from './localApi';
import { supabase, supabaseApi } from './supabaseClient';

function getStorageConfig() {
  // Check if Supabase is configured via environment variables
  if (supabase) {
    return 'supabase';
  }
  
  // Check storage settings
  const saved = localStorage.getItem('sno_storage_config');
  if (saved) {
    const config = JSON.parse(saved);
    return config.storageType === 'supabase' && config.supabaseUrl && config.supabaseKey
      ? 'supabase'
      : 'local';
  }
  return 'local';
}

// Unified API that routes to correct storage
export const unifiedApi = {
  entities: {
    Project: {
      list: async (sortField) => {
        const storageType = getStorageConfig();
        if (storageType === 'supabase') {
          return await supabaseApi.projects.getAll();
        }
        return await localApi.entities.Project.list(sortField);
      },

      get: async (id) => {
        const storageType = getStorageConfig();
        if (storageType === 'supabase') {
          return await supabaseApi.projects.get(id);
        }
        return await localApi.entities.Project.get(id);
      },

      create: async (data) => {
        const storageType = getStorageConfig();
        if (storageType === 'supabase') {
          return await supabaseApi.projects.create(data);
        }
        return await localApi.entities.Project.create(data);
      },

      update: async (id, data) => {
        const storageType = getStorageConfig();
        if (storageType === 'supabase') {
          return await supabaseApi.projects.update(id, data);
        }
        return await localApi.entities.Project.update(id, data);
      },

      delete: async (id) => {
        const storageType = getStorageConfig();
        if (storageType === 'supabase') {
          return await supabaseApi.projects.delete(id);
        }
        return await localApi.entities.Project.delete(id);
      }
    }
  }
};

// Export for convenience
export const api = unifiedApi;
